import Footer from './footer'

const {baseStyle} = Footer

export default {
    baseStyle: {
        footer: {
            ...baseStyle.container,
            paddingTop: {base: '40px', md: '80px', lg: '80px'},
            paddingBottom: {base: '0px', md: '42px', lg: '72px'}
        },
        container: {
            fontSize: '13px',
            color: 'white',
            marginLeft: 'auto',
            marginRight: 'auto',
            fontWeight: 700,
            textTransform: 'uppercase',
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            width: {base: '100%', lg: '1016px'},
            padding: {base: '0 25px', md: '0 30px', lg: '0 40px'}
        },
        ['footer-reassurance']: {
            box: {
                marginBottom: {base: '0px', md: '72px'},
                width: '100%'
            },
            grid: {
                rowGap: '20px',
                placeItems: 'center',
                columns: {base: '2', md: '4'},
                paddingBottom: {base: '24px', md: '36px'},
                borderBottom: {base: 'none', md: '1px solid rgba(170,181,182,.1)'}
            },
            link: {
                width: '160px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '17px',
                textDecoration: 'none',
                _hover: {
                    textDecoration: 'none'
                }
            },
            icon: {
                height: '83px',
                width: '83px',
                fill: 'white'
            },
            htmlText: {
                fontSize: '12px',
                textAlign: 'center',
                pointerEvents: 'none',
                lineHeight: '16px'
            }
        },
        footerModal: {
            heading: {
                padding: '8px 16px',
                display: 'flex',
                justifyContent: 'center',
                background: '#f2f2f2'
            },
            body: {
                margin: '8px 16px',
                padding: '0',

                ['p']: {
                    margin: '16px 0'
                }
            }
        }
    }
}
